const verificationError = "Verification could not be completed. Please try again, or email support@centera.tech.";
const submissionError = "We couldn't confirm your enquiry was received. Please try again, or email support@centera.tech.";

// Keep verification and API failures inside the same recoverable submission path.
export async function submitContact(values, executeRecaptcha, request) {
  if (typeof executeRecaptcha !== "function") throw new Error(verificationError);

  let token;
  try {
    token = await executeRecaptcha("submit_contact_form");
  } catch {
    throw new Error(verificationError);
  }
  if (typeof token !== "string" || !token.trim()) throw new Error(verificationError);

  const data = new FormData();
  for (const [key, value] of Object.entries({
    name: values.full_name,
    email: values.email,
    phone_number: values.phone_number,
    service_id: values.service,
    preferred_contact: values.preferred_contact,
    message: values.message || "",
    recaptcha_token: token,
  })) data.append(key, value);

  try {
    const response = await request("public/add-contact", "POST", data);
    if (response?.data?.status !== true) throw new Error(submissionError);
  } catch (error) {
    if (error.response?.status === 429 || error.response?.status === 409) {
      throw new Error("Too many enquiries have been submitted. Please try again later, or email support@centera.tech.");
    }
    if (error.response?.status === 422) {
      throw new Error("Please check your contact details and selected service, then try again.");
    }
    throw new Error(submissionError);
  }
}
